import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { createNlsMiddleware, userstate } from '@holmescorp/lcc-state';
import css from '../css/status-icon.m.css';
const nls = createNlsMiddleware('ditabook');
const factory = create({ nls, theme, userstate }).properties();
export const StatusIcon = factory(({ properties, middleware: { nls, theme, userstate } }) => {
    const { incompleted, inProgress, completed } = nls().messages;
    const themeCss = theme.classes(css);
    const { key, isBadge = false, useQuizScore = true, quizCompleteOnly = false } = properties();
    const { get, path } = userstate;
    const status = get(path('status'));
    const statusStyle = isBadge ? themeCss.badgeStatusIcon : themeCss.statusIcon;
    const ariaHidden = { hidden: 'true' };
    const statusNotDone = v('span', {
        classes: ['fa-stack', 'fa-1x', statusStyle],
        ...formatAriaProperties({ label: incompleted })
    }, [
        v('i', { classes: ['fas', 'fa-circle', 'fa-stack-1x', 'fa-inverse'], ...formatAriaProperties(ariaHidden) }),
        v('i', {
            classes: ['far', 'fa-circle', 'fa-stack-1x', themeCss.statusNotDone],
            ...formatAriaProperties(ariaHidden)
        })
    ]);
    const statusInProgress = v('span', {
        classes: ['fa-stack', 'fa-1x', statusStyle],
        ...formatAriaProperties({ label: inProgress })
    }, [
        v('i', { classes: ['fas', 'fa-circle', 'fa-stack-1x', 'fa-inverse'], ...formatAriaProperties(ariaHidden) }),
        v('i', {
            classes: ['far', 'fa-check-circle', 'fa-stack-1x', themeCss.statusInProgress],
            ...formatAriaProperties(ariaHidden)
        }),
        v('i', { classes: ['fas', 'fa-spinner', 'fa-stack-1x', 'fa-inverse'], ...formatAriaProperties(ariaHidden) })
    ]);
    const statusComplete = v('span', {
        classes: ['fa-stack', 'fa-1x', statusStyle],
        ...formatAriaProperties({ label: completed })
    }, [
        v('i', { classes: ['fas', 'fa-circle', 'fa-stack-1x', 'fa-inverse'], ...formatAriaProperties(ariaHidden) }),
        v('i', {
            classes: ['far', 'fa-check-circle', 'fa-stack-1x', themeCss.statusComplete],
            ...formatAriaProperties(ariaHidden)
        })
    ]);
    let statusToUse = statusNotDone;
    if (status[key]) {
        const topicStatus = status[key].data;
        const isInProgress = topicStatus.complete > 0 || topicStatus.percent > 0;
        const readingsComplete = topicStatus.complete === topicStatus.total;
        const isComplete = useQuizScore
            ? topicStatus.percent >= 0.8
            : quizCompleteOnly
                ? topicStatus.percent > 0
                : readingsComplete;
        statusToUse = isComplete ? statusComplete : isInProgress ? statusInProgress : statusNotDone;
    }
    return statusToUse;
});
